<template>
  <path
    d="M16.62 2.9903C16.13 2.5003 15.34 2.5003 14.85 2.9903L6.54 11.3003C6.15 11.6903 6.15 12.3203 6.54 12.7103L14.85 21.0203C15.34 21.5103 16.13 21.5103 16.62 21.0203C17.11 20.5303 17.11 19.7403 16.62 19.2503L9.38 12.0003L16.63 4.7503C17.11 4.2703 17.11 3.4703 16.62 2.9903Z"
  />
</template>
